import { httpGet, httpPost } from "./request/requestApi";
const controllerEndpoint = "report";
export class ReportsApi {
    static getFinancialReport(data, abortSignal = undefined) {
        return httpPost(`${controllerEndpoint}/getFinancialReportsData`, {
            abortSignal,
            body: data,
        });
    }
    static getFiscalYearRange(id) {
        return httpGet(`admin/site/fiscalYear/${id}`);
    }
    static isTrackedItemTypeNameUnique(name) {
        return httpGet(`${controllerEndpoint}/validateReportTypeName/${name}`, {
            silent: true,
            area: "trackedItemNameCheck",
        });
    }
    static isTrackedItemNameUnique(name, id) {
        const url = `${controllerEndpoint}/validateReportName`;
        const params = { name: name, companyId: id };
        return httpGet(url, {
            params: params,
            silent: true,
            area: "trackedItemNameCheck",
        });
    }
    static isTrackedItemTypeUnique(type) {
        return httpGet(`${controllerEndpoint}/validateReportType/${type}`, {
            silent: true,
            area: "trackedItemTypeCheck",
        });
    }
    static isFormulaSyntaxValid(formula) {
        return httpPost(`${controllerEndpoint}/validateFormulaSyntax`, {
            silent: true,
            body: formula,
            // area: "trackedItemFormulaCheck",
        });
    }
    static getBudgetReportExcelSheet(data) {
        return httpPost(`${controllerEndpoint}/exportSpreadsheetActualBudget`, {
            body: data,
        });
    }
    static getBandsSummaryForCompanyFinancials() {
        return httpGet(`${controllerEndpoint}/getBandsSummaryForCompanyFinancials`);
    }
    static getCompositeKey(options) {
        return httpGet(`${controllerEndpoint}/composite-index`, Object.assign({ silent: true }, options));
    }
    static getCompositeIndexPrediction(options) {
        return httpGet(`${controllerEndpoint}/composite-index/projection`, Object.assign({ silent: true }, options));
    }
    static getTrackedItemsByEntity(entityId, categoryId, subcategoryId, options) {
        return httpGet(`${controllerEndpoint}/tracked-items/${entityId}/${categoryId}/${subcategoryId}`, Object.assign({ silent: false }, options));
    }
}
